export default {"src":"/_next/static/media/bold_regular.7ca74179.svg","height":24,"width":24};